import * as React from "react";
import { IFormSettingProps } from "../Interfaces/FormProps";

interface IFormPropsContextProviderProps {
  value: IFormSettingProps;
  children: React.ReactNode;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const FormPropsContext = React.createContext<IFormSettingProps | null>(null);

export const useFormPropsContext = () => React.useContext(FormPropsContext);

export const FormPropsContextProvider = (props: IFormPropsContextProviderProps) => {
  return (
    <FormPropsContext.Provider value={props.value}>
      {props.children}
    </FormPropsContext.Provider>
  );
};
